/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */

import React, { Fragment } from "react";

import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

import "./AmountDetails.scss";

function AmountDetails(props) {
  const { details, action, handleLastPayrollClicked, actionPosition, salariesPage } = props;

  return (
    <div className="amount-details-wrapper">
      <div className="amount-details-container">
        <div className="amount-details-content">
          {details && details.length > 0
            ? details.map((detail) => {
                if (detail) {
                  const { title, amount, amountTextColor, subtext, itemClickable, editIcon, onEditClick, showDivider } =
                    detail;

                  return (
                    <Fragment key={title}>
                      <div
                        className={`amount-detail-item ${itemClickable ? "clickable" : ""}`}
                        onClick={itemClickable ? handleLastPayrollClicked : null}
                      >
                        <div className="amount-detail-value">
                          <p className="amount-text" style={{ color: amountTextColor || "" }}>
                            {amount}
                          </p>
                          {editIcon && onEditClick && (
                            <EditOutlinedIcon
                              aria-label={`edit-${title}`}
                              onClick={onEditClick}
                              className="edit-credit-icon"
                            />
                          )}
                        </div>
                        <p className="amount-title">{title}</p>
                        {subtext ? <p className="amount-subtext">{subtext}</p> : null}
                      </div>
                      {showDivider && <div className="amount-detail-divider" />}
                    </Fragment>
                  );
                }
              })
            : null}
        </div>

        {action && salariesPage !== true && (!actionPosition || actionPosition === "right") ? (
          <div className="amount-details-action">{action}</div>
        ) : null}
      </div>

      {action && actionPosition === "bottom" && salariesPage !== true ? (
        <div className="amount-details-action-bottom">{action}</div>
      ) : null}
    </div>
  );
}

export default AmountDetails;
